module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABHNCSVQICAgIfAhkiAAAATFJREFUSEtj/P//PzMDDQEjXS2YM2eO/9+/f3MZGRkNgJ4SINVjQMceYGZmbk5JSTkI0wv3Acjwf//+rSXVUGzqmZiYnGGWwC2YNWvWXqBie6ArNrKxsTUlJiZeJMWy+fPny//69asP6Ht/oL6DaWlpziD9yBb8AQmwsrIqAw1/SIrhMLVAS/R///59Fsj/ALRABKsFQAkWcgyH6QGGBNihMHMwfIDPAlAwAoPwf3p6ugsuR1BqAYrrsFkywiyAJV18kQ7KXMhxQlIQEWMBcpoHOYQkC9Bdjq55NJIxQgAaJ6BcCi5nqB5ExBQhBCOZSoXdR6AvhdELO3BxDcQbgJY0k1NcA0vSXqD+AKzFNc0rHJB3oJbkAZmgKpOfmDBHU3MQWJs1Ya0yyTCMKC00b1UAACYeNygsvRdmAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/more.png
// module id = uty8
// module chunks = 12